/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
import { ALL_SERVICES } from 'pricing-pages-lib/constants/AllAvailableServices';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
import { eligibleAddOnSkuIdsSelector, eligibleServiceSkuIdsSelector } from '../../selectors/RestrictionSelectors';
import ExpandableChecklist from './ExpandableChecklist';
import { PlanBuilderContext } from './PlanBuilder';
import { FormattedCompactTitle, FormattedTitle } from './PlanPickerHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';

const HeaderContainer = ({
  compact,
  children
}) => compact ? /*#__PURE__*/_jsx(FormattedCompactTitle, {
  children: children
}) : /*#__PURE__*/_jsx(FormattedTitle, {
  children: children
});

const AddonsAndServicesPickerList = ({
  compact,
  defaultOpen,
  showServicesSection,
  screen
}) => {
  const {
    productConfigurations,
    setProductConfigurations,
    queryParamTerm
  } = useContext(PlanBuilderContext);
  const allAddonsAndServicesSkuIds = useSelector(state => {
    return [...ALL_AVAILABLE_ADD_ONS, ...ALL_SERVICES].map(apiName => currentSkuIdForProductSelector(state, {
      apiName
    }));
  });
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const eligibleAddOnsSkuIds = useSelector(state => eligibleAddOnSkuIdsSelector(state, {
    selectedProductConfigurations: productConfigurations
  }));
  const eligibleServicesSkuIds = useSelector(state => eligibleServiceSkuIdsSelector(state, {
    selectedProductConfigurations: productConfigurations
  }));
  useEffect(() => {
    if (productConfigurations.some(({
      skuId
    }) => allAddonsAndServicesSkuIds.includes(skuId) && !eligibleAddOnsSkuIds.includes(skuId) && !eligibleServicesSkuIds.includes(skuId))) {
      setProductConfigurations(oldProductConfigurations => oldProductConfigurations.filter(({
        skuId
      }) => !allAddonsAndServicesSkuIds.includes(skuId) || eligibleAddOnsSkuIds.includes(skuId) || eligibleServicesSkuIds.includes(skuId)));
    }
  }, [hasPricingAndPurchasingSucceeded, productConfigurations]);

  const updateSelectedSkus = ({
    value,
    skuId,
    apiName,
    previousValue
  }) => {
    const newProductConfigurations = productConfigurations.filter(itemConfig => itemConfig.skuId !== skuId);

    if (value > 0) {
      newProductConfigurations.push(createProductConfig({
        skuId,
        quantity: value
      }));
    }

    setProductConfigurations(newProductConfigurations);
    getUsageTracker().track('addonsAndServicesInteraction', {
      productName: apiName,
      action: value > previousValue ? 'added item' : 'removed item',
      screen
    });
  };

  const trackAccordionInteraction = (use, isAccordionOpen) => {
    getUsageTracker().track('addonsAndServicesInteraction', {
      action: isAccordionOpen ? `opened ${use}` : `closed ${use}`,
      screen
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ExpandableChecklist, {
      title: /*#__PURE__*/_jsx(HeaderContainer, {
        compact: compact,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.addonsAndServices.addons.title"
        })
      }),
      subtext: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.addonsAndServices.addons.text"
        })
      }),
      skuIds: eligibleAddOnsSkuIds,
      use: "addons",
      selectedProductConfigurations: productConfigurations,
      onSelectedChange: updateSelectedSkus,
      trackAccordionInteraction: trackAccordionInteraction,
      defaultOpen: defaultOpen,
      queryParamTerm: queryParamTerm
    }), showServicesSection && /*#__PURE__*/_jsx(ExpandableChecklist, {
      title: /*#__PURE__*/_jsx(HeaderContainer, {
        compact: compact,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.addonsAndServices.services.title"
        })
      }),
      subtext: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.addonsAndServices.services.text"
        })
      }),
      skuIds: eligibleServicesSkuIds,
      use: "services",
      selectedProductConfigurations: productConfigurations,
      onSelectedChange: updateSelectedSkus,
      trackAccordionInteraction: trackAccordionInteraction,
      defaultOpen: defaultOpen,
      queryParamTerm: queryParamTerm
    })]
  });
};

export default AddonsAndServicesPickerList;